import { Component } from 'react'
import { OrderUserCounters } from 'stylewhere/api'
import { Box, EncodingUserCountersOrderRow, ParcelRowStatus, RowProps } from 'stylewhere/components'
import styled from '@emotion/styled'

interface Props extends RowProps {
  order: OrderUserCounters
  index: number
  onClick: (index: number) => void
}

export class EncodingUserCountersOrder extends Component<Props> {
  render() {
    const { order, index, onClick } = this.props
    return (
      <Box flex pl={0} pr={0}>
        <SessionRow onClick={() => onClick(index)} vcenter>
          <Box row vcenter flex>
            <Session row flex vcenter>
              <Box width={30} vcenter>
                <ParcelRowStatus loading={false} expandable={!order.expanded} expanded={order.expanded} />
              </Box>
              <Box width={300}>{order.orderCode}</Box>
              <Box width={200} center>
                {order.encodings}
              </Box>
              <Box width={200} center>
                {order.totalEncodings + '/' + order.totalQuantity}
              </Box>
            </Session>
          </Box>
          {order.expanded && <EncodingUserCountersOrderRow rows={order.rows} orderIndex={index} />}
        </SessionRow>
      </Box>
    )
  }
}

const SessionRow = styled(Box)`
  border-radius: 10px;
  border-bottom: 1px solid #f6f6f6;
  padding: 15px 0px;
  margin-bottom: 0px;
`

const Session = styled(Box)`
  font-weight: 300;
  font-size: 20px;
  line-height: 24px;
  color: #454545;
  margin-left: 7px;
`
